import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enDocuments from './locales/en/documents.json';
import enSigning from './locales/en/signing.json';
import enProfile from './locales/en/profile.json';
import enAdmin from './locales/en/admin.json';
import enTemplates from './locales/en/templates.json';
import enRecipients from './locales/en/recipients.json';
import enQuicksend from './locales/en/quicksend.json';
import enBilling from './locales/en/billing.json';
import enSigninggate from './locales/en/signinggate.json';
import enPrivacy from './locales/en/privacy.json';

import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frDashboard from './locales/fr/dashboard.json';
import frDocuments from './locales/fr/documents.json';
import frSigning from './locales/fr/signing.json';
import frProfile from './locales/fr/profile.json';
import frAdmin from './locales/fr/admin.json';
import frTemplates from './locales/fr/templates.json';
import frRecipients from './locales/fr/recipients.json';
import frQuicksend from './locales/fr/quicksend.json';
import frBilling from './locales/fr/billing.json';
import frSigninggate from './locales/fr/signinggate.json';
import frPrivacy from './locales/fr/privacy.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        dashboard: enDashboard,
        documents: enDocuments,
        signing: enSigning,
        profile: enProfile,
        admin: enAdmin,
        templates: enTemplates,
        recipients: enRecipients,
        quicksend: enQuicksend,
        billing: enBilling,
        signinggate: enSigninggate,
        privacy: enPrivacy,
      },
      fr: {
        common: frCommon,
        auth: frAuth,
        dashboard: frDashboard,
        documents: frDocuments,
        signing: frSigning,
        profile: frProfile,
        admin: frAdmin,
        templates: frTemplates,
        recipients: frRecipients,
        quicksend: frQuicksend,
        billing: frBilling,
        signinggate: frSigninggate,
        privacy: frPrivacy,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'documents', 'signing', 'profile', 'admin', 'templates', 'recipients', 'quicksend', 'billing', 'signinggate', 'privacy'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
